module.exports = __webpack_public_path__ + "img/logo-black.354aec96.png";